import type { RoleConfig } from '../types.js';

export const mole: RoleConfig = {
  id: 'mole',
  faction: 'mafia',
  title: { ru: 'Крот', uk: 'Кріт' },
  latin: 'MOLE',
  number: '38',
  accent: '#6a5a3a',
  ability: {
    ru: 'Ночью узнаёт, способен ли игрок убивать — мафия видит, кто из мирных опасен.',
    uk: 'Вночі дізнається, чи здатен гравець вбивати — мафія бачить, хто з мирних небезпечний.',
  },
  abilities: [
    { key: 'investigate', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  reveals: { factions: ['mafia'] },
  victory: { type: 'mafia' },
};
